export default __webpack_public_path__ + "static/media/link.737bbb5c.png";